





















import { defineComponent, provide, reactive, ref, toRef, watch } from "@vue/composition-api";
import { CollabLiveChat, CollabLiveChatStatus } from "@scrile/api-provider/dist/api/CollabLiveChatsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { getProfileUrl } from "@/lib/urlHelpers";
import CallsLogger from "@/modules/callsLogger";
import ConsumeController from "./components/ConsumeController";
import ProduceController from "./components/ProduceController";
import StreamModal from "../components/StreamModal.vue";

export default defineComponent({
  name: "CollabLiveController",
  components: { StreamModal, ProduceController, ConsumeController },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
    chatId: { type: String, required: true },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();

    const collabLive = ref<CollabLiveChat | null>(null);
    const loading = ref(true);
    const isProducer = ref(false);

    const checkCollabChat = async () => {
      try {
        loading.value = true;
        const response = await providers.CollabLiveChatsProvider.search({
          data: {
            ids: [props.chatId],
            status: CollabLiveChatStatus.ACTIVE,
          },
        });
        collabLive.value = response[0] ?? null;
        const ownerAllowStream = collabLive.value?.broadcasterUserIds.includes(props.user.id) ?? false;
        if (!collabLive.value || !ownerAllowStream) {
          await root.$router.replace(getProfileUrl(props.user));
          return;
        }
        isProducer.value = props.user.id === authUser.value?.id;
      } finally {
        loading.value = false;
      }
    };

    const onClose = () => {
      CallsLogger.collectLogs(`[STREAM CONTROLLER] - Close`, { streaming: false });
      root.$router.push(getProfileUrl(props.user));
    };

    const provided: { user: UserPublicData | null } = reactive({ user: props.user });
    watch(toRef(props, "user"), user => (provided.user = user));
    provide("messageData", provided);

    if (props.user.role === "member") {
      onClose();
    }

    checkCollabChat();

    return {
      isProducer,
      collabLive,
      loading,
      onClose,
    };
  },
});
